import styled from 'styled-components';
import {
  IconButton,
  Typography,
  Divider as MuiDivider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const Box = styled.div`
  position: absolute;
  border-radius: 5px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  min-width: 100px;
  max-width: 1000px;
  background-color: white;
  height: auto;
  min-height: 100px;
  padding: 10px;
`;

export const Content = styled.div`
  width: 100%;
`;

export const DetailsContainer = styled.div`
  position: relative;
  flexgrow: 1;
`;

export const Icon = styled(IconButton)`
  position: absolute;
  right: 10px;
  top: 0px;
`;

export const Divider = styled(MuiDivider)`
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const Title = styled(Typography)`
  width: 100%;
  text-align: center;
  margin-top: 20px !important;
  margin-bottom: 20px !important;
  font-size: 1.2rem !important;
`;

export const LoadContainer = styled.div`
  width: 100%;
  margin-top: 55px;
`;

export const IconClose = styled(CloseIcon)`
  position: absolute;
  right: 5px;
  top: 0px;
  cursor: pointer;
  font-size: 14px !important;
`;

export const Details = styled.div`
  position: relative;
  padding-top: 20px;
`;